// Bandeau d'alerte : se replie en une ligne « Afficher » pour la session,
// et se rouvre de lui-même dès que la liste des alertes change.
export default function alerte() {
    const bandeau = document.querySelector(".alerte[data-alerte]");
    if (!bandeau) return;

    const cle = "mz-alerte-" + bandeau.dataset.alerte;
    const fermer = bandeau.querySelector(".alerte-close");
    const ouvrir = bandeau.querySelector(".alerte-ouvrir");
    if (!fermer || !ouvrir) return;

    const replier = (etat) => {
        bandeau.classList.toggle("repliee", etat);
        ouvrir.hidden = !etat;
        fermer.setAttribute("aria-expanded", String(!etat));
        ouvrir.setAttribute("aria-expanded", String(!etat));
        try { etat ? sessionStorage.setItem(cle, "1") : sessionStorage.removeItem(cle); } catch (e) { /* ignore */ }
    };

    try { if (sessionStorage.getItem(cle)) replier(true); } catch (e) { /* ignore */ }

    fermer.addEventListener("click", () => { replier(true); ouvrir.focus(); });
    ouvrir.addEventListener("click", () => { replier(false); fermer.focus(); });
}
